import request from 'sb-request'
import actions from 'redux/actions'
import { constants, mixpanel } from 'common/helpers'

import subscriptionProcessing from './subscriptionProcessing'


const setupCommit = ({ endpoint, tokenName, withProgressRequest, withErrorModal = true }) => (values = {}) => {
  const params = {
    body: values,
    tokenName,
    withErrorModal,
  }

  mixpanel.track(constants.analyticsEvents.tech.commitStart)

  return request.post(endpoint, params)
    .then(
      (result) => {
        mixpanel.track(constants.analyticsEvents.tech.commitSuccess)

        return result
      },
      ({ error, message, title, statusCode, resData }) => {
        mixpanel.track(constants.analyticsEvents.tech.commitError)

        if (resData.token) {
          actions.models.requestTokens.update({
            [tokenName]: resData.token,
          })
        }

        return withProgressRequest && values.subscriptionSession && (error === 'timeout' || statusCode === 504)
          ? subscriptionProcessing({ subscriptionSession: values.subscriptionSession })
          : Promise.reject({ error, message, title, statusCode, resData })
      }
    )
}


export default setupCommit
